import __request__ from "routing/request";
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/events/notifications", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listNotifications(page = 1, per_page = 50, query, requestOptions) {
  return __request__("GET", "/events/notifications", null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function legacyTypes(requestOptions) {
  return __request__("GET", "/events/notifications/legacy/types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/events/notifications/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function test(JSONBody, requestOptions) {
  return __request__("POST", "/events/notifications/test", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(notificationId, requestOptions) {
  return __request__("GET", `/events/notifications/${notificationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(notificationId, JSONBody, requestOptions) {
  return __request__("PUT", `/events/notifications/${notificationId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(notificationId, requestOptions) {
  return __request__("DELETE", `/events/notifications/${notificationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testBynotificationId(notificationId, requestOptions) {
  return __request__("POST", `/events/notifications/${notificationId}/test`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
